import { useEffect, useRef, useState } from "react";

// Poloměry v kilometrech – 0 znamená pouze přesnou polohu
export const RADIUS_OPTIONS = [0, 5, 10, 20, 50, 100];

export const DEFAULT_RADIUS = 5;

/**
 * Výběr poloměru hledání. Komponenta se vykreslí až po výběru lokality,
 * protože bez ní nemá smysl.
 */
const RadiusSelect = ({ value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen && !selectRef.current?.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () =>
            document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    const radius = RADIUS_OPTIONS.includes(value) ? value : DEFAULT_RADIUS;

    return (
        <div className="custom-select-wrapper" ref={selectRef}>
            <div
                className={`custom-select-down ${isOpen ? "open" : ""}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="selected">+ {radius} km</span>
                <span className={`arrow ${isOpen ? "rotate" : ""}`}>▼</span>
            </div>

            {isOpen && (
                <div className="options-down">
                    {RADIUS_OPTIONS.map((option) => (
                        <div
                            key={option}
                            className={`option ${
                                radius === option ? "selected" : ""
                            }`}
                            onClick={() => {
                                onChange(option);
                                setIsOpen(false);
                            }}
                        >
                            + {option} km
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RadiusSelect;
